// nodemodule imports
import styled from "styled-components";
import React, {useState} from 'react';
import { Link } from 'react-router-dom'


// project imports
import { config } from "../../../config";
import Icon from '../../reusable/Icon'
import navigation_doc from "./navigation.json";


export default ({doc}) => {
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(doc)

  const highlight = (id) => {
    let element = document.getElementById(id);

    element.style.boxShadow = 'inset 0px 0px 30px rgba(0, 0, 0, 0.04)';
  }

  const unHighlight = (id) => {
    let element = document.getElementById(id);

    element.style.boxShadow = 'none';
  }

  return (
    <>
      <Nav>
        <Logo2 width={186} alt={config.apiLogo} src={config.apiLogo} />
        <HaburgerWrapper onClick={()=>setOpen(!open)}>
          <Icon margin="0px 0px 0px 0px" width={24} icon="hamburger" />
        </HaburgerWrapper>
      </Nav>
      <Wrapper open={open}>
        <Logo width={186} alt={config.apiLogo} src={config.apiLogo} />
        {navigation_doc.map(doc => (
          <>
            <Title>
              <Link to={doc.href}>
                <TitleAnchor href={doc.href} onClick={() => setSubmenuOpen(doc.title)}>{doc.title}</TitleAnchor>
              </Link>
            </Title>
            <Ul open={submenuOpen === doc.title}>
              {doc.children.map((section, index) => (
                <A
                  id={`${section.name}${index}`}
                  onMouseEnter={() => highlight(`${section.name}${index}`)}
                  onMouseLeave={() => unHighlight(`${section.name}${index}`)}
                  href={section.href}
                >
                  {section.name}
                </A>
              ))}
            </Ul>
          </>
        ))}
      </Wrapper>
    </>
  )
}

const Ul = styled.div(props => ({
  display: props.open ? "initial" : "none",
  margin: 0,
  padding: 0,
  width: '100%'
}));

const Title = styled.div(props => ({
  margin: '19px 0 6px 0',
}));

const TitleAnchor = styled.a(props => ({
  color: '#1F4AAD',
  textDecoration: 'none',
  fontSize: 14,
  lineHeight: 'auto',
  fontWeight: 500,
  paddingLeft: 48,
}));

const Nav = styled.a(props => ({
  width:"calc(100vw - 48px)",
  position:"fixed",
  display:"flex",
  alignItems:"center",
  justifyContent:"space-between",
  zIndex: 10,
  top:0,
  left:0,
  background:"#fff",
  padding:24,
  "@media (min-width: 901px)": {
    display:"none",
  },
}));

const HaburgerWrapper = styled.a(props => ({
  width:24,
  height:24,
}));

const A = styled.a(props => ({
  listStyleType: 'none',
  cursor:"pointer",
  padding: '6px 0 5px 48px',
  color: '#949494',
  textDecoration: 'none',
  fontSize: 14,
  lineHeight: 'auto',
  fontWeight: 500,
  display:"block",
}));

const Logo = styled.img(props => ({
  width:props.width,
  cursor:"pointer",
  marginBottom:54,
  marginLeft:48,
}));

const Logo2 = styled.img(props => ({
  width:props.width,
  cursor:"pointer",
}));

const Wrapper = styled.div(props => ({
  height: '100vh',
  width: 280,
  minWidth:280,
  minHeight:740,
  paddingTop:24,
  position:"fixed",
  zIndex:1,
  top:0,
  left: 0,
  background:"#fff",
  transition:"0.2s ease-in-out",
  boxShadow: 'inset 0px 0px 30px rgba(0, 0, 0, 0.04)',
  "@media (max-width: 900px)": {
    left:props.open ? 0 : -280,
    boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.04)',
  },
}));
